<template>
  <div class="page-themes">
    <PageHeader>
      <h1>Themes</h1>

      <Btn primary>
        <router-link :to="{name: 'add-theme'}">
          Add Theme
        </router-link>
      </Btn>
    </PageHeader>

    <div class="page-columns">
      <div class="col main">
        <div class="page-content">
          <table-data
            :rows="themes"
            :headings="[
              {heading: 'Theme Name', key: 'theme-name'},
              {heading: 'Theme Slug', key: 'slug'}
            ]"
            :pagination="pagination"
          >
            <div
              v-for="(theme, index) in themes"
              :slot="'td-' + index + '-theme-name'"
              :key="index"
            >
              <router-link :to="{name: 'edit-theme', params: {themeId: theme.id}}">
                {{ theme.name }}
              </router-link>
            </div>
          </table-data>

          <pagination @changePage="changePage" :pagination="pageData">
          </pagination>
        </div>
      </div>

      <div class="col side">
        <PageSummary>
          <div>
            <h1>Themes</h1>
            <p>
              These are themes available to our customers. When adding a new theme, be sure that the CSS in <strong>GUI</strong> has been deployed to prevent customers applying themes that have no styling associated with it!
            </p>
          </div>
        </PageSummary>
      </div>
    </div>

    <router-view />
  </div>
</template>

<script>
import page from '@/mixins/page'
import pagination from '@/mixins/pagination'

import {readThemesData} from '@/lib/themes'

import Table from '@/components/Table'
import PageHeader from '@/components/PageHeader'
import PageSummary from '@/components/PageSummary'
import Btn from '@/components/Btn'

export default {
  name: 'themes',

  mixins: [page, pagination],

  components: {
    TableData: Table,
    PageHeader,
    PageSummary,
    Btn
  },

  data() {
    return {
      themes: [],
      errors: {},
      title: 'Themes'
    }
  },

  methods: {
    getData() {
      readThemesData(this.pagination).then(({data, page}) => {
        this.themes = data
        this.pageData = page
      })
    }
  },

  mounted() {
    this.getData()
  },

  watch: {
    $route: function() {
      this.getData()
    }
  }
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/helpers/mixins'
@import '../stylesheets/helpers/extends'

.page-themes
  @extend %page
</style>
